import type { PropsWithChildren } from "react";
import { useEffect, useRef, useState } from "react";
import { useIsLogged } from "../../../../hooks/auth/use-is-logged/use-is-logged";
import BonusXLoading from "../../../components/BonusXLoading";
import { useClientConstantsReplacements } from "../../../hooks/use-client-constants/use-client-constants-replacements/use-client-constants-replacements";
import { clientConstantsServiceInstance } from "../client-constants.service.instance";

export function ClientConstantsProvider({ children }: Readonly<PropsWithChildren<{}>>) {
  const isLogged = useIsLogged();
  const [serviceReady, setServiceReady] = useState(false);
  const { revalidateReplacements } = useClientConstantsReplacements();
  const wasLoggedInOnMount = useRef(isLogged);

  useEffect(
    function initializeClientConstantsService() {
      if (!isLogged) {
        setServiceReady(false);
        return;
      }

      let cancelled = false;

      async function initService() {
        await clientConstantsServiceInstance.initialize();
        if (cancelled) {
          return;
        }

        revalidateReplacements();
        setServiceReady(true);
      }

      initService();

      return function cleanup() {
        cancelled = true;
      };
    },
    [isLogged]
  );

  const isLoading = isLogged && !serviceReady && wasLoggedInOnMount.current;
  if (isLoading) {
    return <BonusXLoading />;
  }

  return <>{children}</>;
}
